module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-17@2x-e31352c4276a0a9f42fe1a5a17268aa5.png";